<script>
    import { Icon } from "@axel669/zephyr"
</script>

<Icon name="home" />
<Icon name="x" />
